

import '@/assets/scss/index.scss'
// import * as pd from '@/scriptData/pd/rcmdLabel'
import dayjs from 'dayjs'
import { pdMixin } from '@/mixin/pd/pdMixin'
import BoxPdEmblem from '~/components/common/product/BoxPdEmblem.vue'
import BoxPdFlag from '~/components/common/product/BoxPdFlag.vue'
import CommonImage from '~/components/common/CommonImage.vue'
import CommonVideo from '~/components/common/CommonVideo.vue'
import { getCapturedImageUrl } from '~/scriptData/common/interM2'

export default {
  components: {
    CommonVideo,
    CommonImage,
    BoxPdEmblem,
    BoxPdFlag
  },
  mixins: [pdMixin],
  props: {
    unitType: { // component 노출 타입
      type: String,
      default: ''
    },
    viewType: { // 화면 구성 타입 (gnr: 일반, bun: 세트상품, gf: 상품권)
      type: String,
      default: ''
    },
    pdUnit: { // 상품상세 정보
      type: Object,
      default: () => {
        return {}
      }
    },
    brndUnit: { // 브랜드 정보
      type: Object,
      default: () => {
        return {}
      }
    },
    isOpenRun: {
      type: Boolean,
      default: false
    },
    opRunDt: { // 판매시작일시 포맷
      type: String,
      default: ''
    },
    recommendData: { // 추천 문구
      type: String,
      default: ''
    },
  },
  data () {
    return {
      labelData: [], // 추천셋 문구 리스트
      thumActive: 0, // 23.10.10 상품 썸네일 슬라이드 동기화 위한 데이터
      // 상품 섬네일 이미지 스와이퍼
      thumbSwiperOption: {
        // 23.08.24 옵션 변경
        slidesPerView: 1,
        spaceBetween: 8,
        lazy: true,
        // 23.10.06 루프 삭제
        // loop: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.goods-thumb .swiper-button-next',
          prevEl: '.goods-thumb .swiper-button-prev'
        },
        // 23.10.10 pagination 추가
        pagination: {
          el: '.goods-thumb .swiper-pagination',
          clickable: false,
          type: 'fraction',
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span><span class="' + totalClass + '"></span>'
          }
        }
      },
      // 썸네일 스와이퍼
      thumbListSwiperOption: {
        // 23.08.21 perview 값 변경
        // 23.08.24 옵션 변경
        slidesPerView: 5,
        spaceBetween: 8,
        lazy: true,
        // 23.10.06 루프 삭제
        // 기능 추후 확인 요망 (센터모드가 아닐 시 루프상태가 아니라면 끝 썸네일까지 이동 불가능함)
        // loop: true,
        // loopedSlides: 5,
        observer: true,
        observeParents: true,
        slideToClickedSlide: true,
        touchRatio: 0.2,
        // 23.08.16 스와이퍼 버튼 추가
        navigation: {
          nextEl: '.goods-swiper-thums .swiper-button-next',
          prevEl: '.goods-swiper-thums .swiper-button-prev'
        }
        // --
      },
      timerDay: null,
      timerInterval: null,
      timerCount: 0,
      timerTextDay: 0,
      timerTextHours: '00',
      timerTextMinutes: '00',
      timerTextSeconds: '00',
      isTodayOpRun: false, // 금일 판매시작 여부
      recommendDataObj: {
        prefix: '',
        numberWithUnit: '',
        suffix: ''
      }
    }
  },
  computed: {
  },
  watch: {
    recommendData (value) {
      if (value) {
        this.parseViewerRecommendData() // 문장형 추천 문구 영역 나누기
      }
    }
  },
  mounted () {
    if (this.unitType === 'dtlThumb') {
      // 검색솔루션 문구 제공 (세트상품 노출 안함)
      // 2024-07-09 뷰티데이대비로 검색엔진 영억 제거
      // if (this.viewType !== 'bun') {
      //   this.$AxiosBuilder
      //     .params({ searchQuery: 'Q1', searchTerm: this.pdUnit.pdNo, userId: this.$store.getters['session/getMb'].mbEid ? this.$store.getters['session/getMb'].mbEid : '' })
      //     .baseURL(process.env.API_SSN_BASE_URL)
      //     .build()
      //     .get('/totalSearch')
      //     .then((res) => {
      //       const rstDcmt = res.data.resultSet.result[1].resultDocuments[0]
      //       this.labelData = this.isNotEmpty(rstDcmt) ? pd.getRcmdLabel(rstDcmt, this.pdUnit.pdTy) : []
      //     }).catch((e) => {
      //       console.log('pdInfoUnit error :', e)
      //     })
      // }

      // 썸네일 스와이퍼 길이 1 미만일 시 스와이퍼 중단
      if (this.pdUnit.ctts.length <= 1) {
        this.swiperDestroy()
      }
      this.$nextTick(() => { // 썸네일 스와이퍼 적용 위한 초기화
        this.videoLazyCtrl() // 23.10.16 video(자동재생) 정지/재생 기능
      })
    }
    if (this.isOpenRun) {
      this.HtmlTimerHandler()
      const sleStDtm = dayjs(this.pdUnit.sleStDtm).subtract(24, 'hour').format('YYYYMMDDHH')
      const now = dayjs().format('YYYYMMDDHH')
      if (sleStDtm <= now) {
        this.isTodayOpRun = true
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timerInterval)
  },
  methods: {
    getCapturedImageUrl,
    swiperDestroy () {
      this.$refs.goodsSwiper.swiper.destroy()
    },
    // swiperThumbs () { // 썸네일 스와이퍼 적용(제거)
    //   const goodsSwiper = this.$refs.goodsSwiper.swiper
    //   const goodsSwiperThums = this.$refs.goodsSwiperThums.swiper
    //   // 23.08.24 기능 변경
    //   goodsSwiper.controller.control = goodsSwiperThums
    //   goodsSwiperThums.controller.control = goodsSwiper
    // },

    // 23.10.10 함수 추가
    goodsSlideChange () {
      const goodsSwiper = this.$refs.goodsSwiper.swiper
      const goodsSwiperThums = this.$refs.goodsSwiperThums.swiper

      this.thumActive = goodsSwiper.activeIndex
      goodsSwiperThums.slideTo(this.thumActive)
    },

    thumbsClick (index) {
      const goodsSwiper = this.$refs.goodsSwiper.swiper
      this.thumActive = index
      goodsSwiper.slideTo(this.thumActive)
    },

    thumbsBtnClick (e) {
      const goodsSwiper = this.$refs.goodsSwiper.swiper
      if (e.target.classList.contains('swiper-button-prev')) {
        this.thumActive -= 1
        goodsSwiper.slideTo(this.thumActive)
      } else {
        this.thumActive += 1
        goodsSwiper.slideTo(this.thumActive)
      }
    },
    // 23.10.16 동영상 관련 함수 정의
    videoLazyCtrl () { // video(자동재생) 정지/재생 기능
      // 자동재생 video 선택자 (class auto)
      const lazyVideo = this.isNotEmpty(this.$refs.lazyVideo) ? this.$refs.lazyVideo : []

      // 옵션 (video 선택자가 viewprot에 교차되는 옵션 설정)
      const options = {
        root: null,
        rootMargin: '-250px -40px -250px -40px',
        threshold: [0.4]
      }

      // 콜백함수
      const onSensor = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting === false) { // 동영상이 화면에서 벗어날 때
            // data id값으로 해당 컴포넌트 접근하여 작업 (퍼블 예시)
            if (entry.target.closest('.video-wrap') === null) { return false } // video 선택자 못 가져올 경우 return
            const valId = entry.target.closest('.video-wrap').getAttributeNode('id').value.slice(6)
            this.stop(valId)

            // 스와이프 실행시 영상 초기화(단말기 테스트시 slide 체크 못하면 swiper event로 대체)
            if (entry.target.closest('.swiper-slide').classList.contains('swiper-slide-active') === false) {
              this.reload(valId)
            }
          } else if (entry.isIntersecting === true) { // 동영상이 화면에 진입할 때
            // data id값으로 해당 컴포넌트 접근하여 작업 (퍼블 예시)
            if (entry.target.closest('.video-wrap') === null) { return false } // video 선택자 못 가져올 경우 return
            const valId = entry.target.closest('.video-wrap').getAttributeNode('id').value.slice(6)
            this.play(valId)
          }
        })
      }

      // 인스턴스
      const videoIob = new IntersectionObserver(onSensor, options) // 메뉴(상세, 전시, 콘텐츠커머스)별로 관리가 필요할 시 인스턴스 추가

      // 실행
      lazyVideo.forEach((video) => {
        videoIob.observe(video)
      })
    },

    play (val) { // 재생
      if (Array.isArray(this.$refs[`video${val}`])) { // data type 배열
        console.log('재생', 'component:', this.$refs[`video${val}`])
        this.$refs[`video${val}`][0].player.play()
      } else {
        console.log('재생', 'component:', this.$refs[`video${val}`])
        this.$refs[`video${val}`].player.play()
      }
    },
    stop (val) { // 정지
      if (Array.isArray(this.$refs[`video${val}`])) { // data type 배열
        console.log('정지', 'component:', this.$refs[`video${val}`][0])
        this.$refs[`video${val}`][0].player.pause()
      } else {
        console.log('정지', 'component:', this.$refs[`video${val}`])
        this.$refs[`video${val}`].player.pause()
      }
    },
    muted (val) { // 음소거
      if (val.ref !== undefined) {
        if (Array.isArray(this.$refs[val.ref])) {
          console.log('음소거', 'component:', this.$refs[val.ref][0].$refs[`video${val.id}`])
          this.$refs[val.ref][0].$refs[`video${val.id}`].player.muted(val.checked)
        } else if (Array.isArray(this.$refs[val.ref].$refs[`video${val.id}`])) {
          console.log('음소거', 'component:', this.$refs[val.ref].$refs[`video${val.id}`][0])
          this.$refs[val.ref].$refs[`video${val.id}`][0].player.muted(val.checked)
        } else {
          console.log('음소거', 'component:', this.$refs[val.ref].$refs[`video${val.id}`])
          this.$refs[val.ref].$refs[`video${val.id}`].player.muted(val.checked)
        }
      } else if (Array.isArray(this.$refs[`video${val.id}`])) {
        console.log('음소거', 'component:', this.$refs[`video${val.id}`][0])
        this.$refs[`video${val.id}`][0].player.muted(val.checked)
      } else {
        console.log('음소거', 'component:', this.$refs[`video${val.id}`])
        this.$refs[`video${val.id}`].player.muted(val.checked)
      }
    },
    fullScreen (val) { // 전체보기
      if (val.ref !== undefined) {
        console.log('전체보기', 'component:', this.$refs[val.ref].$refs[`video${val.id}`][0])
        this.$refs[val.ref].$refs[`video${val.id}`][0].player.requestFullscreen()
      } else if (Array.isArray(this.$refs[`video${val.id}`])) {
        console.log('전체보기', 'component:', this.$refs[`video${val.id}`][0])
        this.$refs[`video${val.id}`][0].player.requestFullscreen()
      } else {
        console.log('전체보기', 'component:', this.$refs[`video${val.id}`])
        this.$refs[`video${val.id}`].player.requestFullscreen()
      }
    },
    reload (val) { // 영상 리로드 (스와이프에서 사용)
      console.log('리로드', 'component:', this.$refs[`video${val}`][0])
      this.$refs[`video${val}`][0].player.load()
    },

    // 공유하기 팝업 호출
    openLayerShareSns () {
      this.$emit('openLayerShareSns', { name: 'shareSns', data: { title: '상품상세', description: this.pdUnit.exhPdNm } })
    },

    // 타이머
    initTimer () {
      this.timerTextDay = 0
      this.timerTextHours = '00'
      this.timerTextMinutes = '00'
      this.timerTextSeconds = '00'
      this.timerCount = 0
    },
    HtmlTimerHandler () {
      this.initTimer()
      this.timerInterval = setInterval(this.dayCount, 1000)
    },
    dayCount () {
      const now = dayjs()
      const timeGap = dayjs(this.pdUnit.sleStDtm).diff(now, 'second')
      this.timerTextHours = String(Math.floor(timeGap / 3600)).padStart(2, '0')
      this.timerTextMinutes = String(Math.floor((timeGap % 3600) / 60)).padStart(2, '0')
      this.timerTextSeconds = String(timeGap % 60).padStart(2, '0')

      this.timerCount += 1

      if (timeGap <= 0 || this.timerCount > 500) {
        clearInterval(this.timerInterval)
        this.disabled = true
        return false
      }

      if (this.disabled) {
        this.disabled = false
      }
    },
    resetFilterCheck () {
      sessionStorage.setItem('preFilterCheck', sessionStorage.getItem('filterCheck'))
      sessionStorage.setItem('filterCheck', [])
    },
    parseViewerRecommendData () {
      if (this.isEmpty(this.recommendData)) {
        return
      }
      const matchNumber = this.recommendData.match(/^(.*?)([\d,]+명)(.*?)$/) // "숫자명"까지 찾아서 분리
      const matchAge = this.recommendData.match(/^(.*?)(\d+대(?:\s*이상)?\s*(?:남성|여성)?)(.*?)$/) // "이상" 패턴 추가
      // 우선순위 : matchNumber > matchAge
      const parseData = {}
      if (matchNumber) {
        parseData.prefix = matchNumber[1] || '' // "지금 "
        parseData.numberWithUnit = matchNumber[2] || '' // "256명"
        parseData.suffix = matchNumber[3] || '' // "이 보고 있어요"
        this.recommendDataObj = parseData
      } else if (matchAge) {
        parseData.prefix = matchAge[1] || '' // ""
        parseData.numberWithUnit = matchAge[2] || '' // "10대"
        parseData.suffix = matchAge[3] || '' // " 여성이 가장 많이 봤어요"
        this.recommendDataObj = parseData
      }
    }
  }
}
